
export default
{
    path: "bill",
    meta: {
        title: "账单管理"
    },
    component: () => import("@/layouts/item"),
    children: [
        {
            path: "bill-add",
            component: () => import("@/pages/bill/bill-add"),
            meta: {
                title: "账单添加"
            }
        },
        {
            path: "bill-copy",
            component: () => import("@/pages/bill/bill-copy"),
            meta: {
                title: "账单复制"
            }
        },
        {
            path: "goods",
            component: () => import("@/pages/bill/goods.vue"),
            meta: {
                title: "账单复制"
            }
        },


    ]
}

